import { CDN_URL, MATERIAL_ICONS_PATH } from '../constants';
import { IconName, IconTheme } from '../types';

export const getIconUrl = (
  iconName: IconName,
  iconTheme: IconTheme = 'outline',
): string => {
  return `${CDN_URL}${MATERIAL_ICONS_PATH}/${iconName}/${iconTheme}.svg`;
};
